/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutRankingBottom.vue?vue&type=template&id=6192147c&scoped=true"
import script from "./LayoutRankingBottom.vue?vue&type=script&lang=js"
export * from "./LayoutRankingBottom.vue?vue&type=script&lang=js"
import style0 from "./LayoutRankingBottom.vue?vue&type=style&index=0&id=6192147c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192147c",
  null
  
)

export default component.exports